import { PublicFilesFolderPageHeaderQuery } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import DocumentsResourceHeader from 'modules/documents/components/DocumentsResourceHeader'
import { getTitle } from 'modules/documents/lib/Folders'

export type Folder =
  PublicFilesFolderPageHeaderQuery['documents']['ancestors']['edges'][number]['node']
export type Policies = PublicFilesFolderPageHeaderQuery['documents']['_policies']

interface Props {
  folder: NonNullable<Folder>
  policies: Policies
}

const FolderDocumentsPageHeader = ({ folder, policies }: Props) => {
  const { navigation } = useNavigation()

  const title = getTitle(folder.name)

  const canUploadDocument =
    policies?.companyEditPublicDocuments?.can || policies?.companyUseCompanyDocuments?.can

  const url = navigation.files.companyFiles.folderId.new.fullPath({ folderId: folder.id })

  return <DocumentsResourceHeader title={title} canUploadDocument={canUploadDocument} url={url} />
}

export default FolderDocumentsPageHeader
